import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { TerminalManageDataSource } from './terminal-manage-datasource';
import { TerminalService } from 'src/app/services/terminal.service';
import { Terminal } from 'src/app/models/terminal';
import { TerminalManageDialogComponent } from '../terminal-manage-dialog/terminal-manage-dialog.component';
import { UserService } from 'src/app/services/user.service';
import { Define } from '@app/models/define';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';


@Component({
  selector: 'app-terminal-manage',
  templateUrl: './terminal-manage.component.html',
  styleUrls: ['./terminal-manage.component.css']
})
export class TerminalManageComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: TerminalManageDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns: string[];

  serialId: string;

  constructor(
    private terminalService: TerminalService,
    private userService: UserService,
    public dialog: MatDialog
  ) { }

  async ngOnInit() {
    this.serialId = localStorage.getItem('serialId');
    const data = await this.terminalService.getTerminals();
    this.dataSource = new TerminalManageDataSource(this.paginator, this.sort, data);
    const auth = await this.userService.getCurrentManageAuth();
    if (auth === undefined || auth < Define.ManageAuthority.Administrator) {
      this.displayedColumns = ['name', 'borderHour', 'serialId', 'yakusyaTerminalId', 'edit'];

    } else {
      this.displayedColumns = ['name', 'borderHour', 'serialId', 'yakusyaTerminalId', 'edit', 'delete'];

    }

  }


  openDialog(rowData: Terminal) {

    console.log(`openDialog open`);

    const data = Object.assign({}, rowData);
    const dialogRef = this.dialog.open(TerminalManageDialogComponent, { data, maxWidth: '95vw' });
    dialogRef.afterClosed().subscribe(result => {
      console.log(`dialog close. result:${result}`);
      if (this.dataSource !== undefined && result === true) {
        this.ngOnInit();
      }
    });
  }

  delete(rowData: Terminal) {
    console.log(`delete terminal`);
    console.log(rowData);
    const data = '削除します。よろしいですか？';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, { data });
    dialogRef.afterClosed().subscribe(async result => {
      if (result === true) {
        await this.terminalService.delete(rowData);
        this.ngOnInit();
        console.log(`delete terminal execute`);
      }
    });

  }
}
